module.exports = __webpack_public_path__ + "img/pic_2.cd624db3.png";